import styled from "styled-components";
import { TitleText, MetaText } from "../atoms/Text";

const Wrapper = styled.section`
  padding: 16px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
`;

const TopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const Below = styled.div`
  margin-top: 12px;
`;

export function PageHeader({ title, description, actions, children }) {
  return (
    <Wrapper>
      <TopRow>
        <Left>
          <TitleText>{title}</TitleText>
          {description ? <MetaText>{description}</MetaText> : null}
        </Left>

        {actions ? <Right>{actions}</Right> : null}
      </TopRow>

      {children ? <Below>{children}</Below> : null}
    </Wrapper>
  );
}